import React, { useState, useEffect } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';


import { IoImagesOutline } from "react-icons/io5";

export default function WebsiteServices(){
    
    return (
        <section className='pt-5 pb-5 service-row'>
            <Container>
                <div className="text-center">
                    <h3>Big Sauda services</h3>
                    <p>Vestibulum tempor enim metus, quis tempor urna facilisis sed. Sed nibh ipsum,  vitae, molestie vestibulum quam. </p>
                </div>
                <Row>
                    <Col xl={4}>
                        <Card className='border-0 feature mt-3 mt-xl-0'>
                            <i className="p-4"><IoImagesOutline /></i>
                            <Card.Body>
                                <h5>Smart Property Search</h5>
                                <p>Easily find properties tailored to your needs with advanced filters and map-based search.</p>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xl={4}>
                        <Card className='border-0 feature mt-3 mt-xl-0'>
                            <i className="p-4"><IoImagesOutline /></i>
                            <Card.Body>
                                <h5>Smart Property Search</h5>
                                <p>Easily find properties tailored to your needs with advanced filters and map-based search.</p>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xl={4}>
                        <Card className='border-0 feature mt-3 mt-xl-0'>
                            <i className="p-4"><IoImagesOutline /></i>
                            <Card.Body>
                                <h5>Smart Property Search</h5>
                                <p>Easily find properties tailored to your needs with advanced filters and map-based search.</p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}